<template>
  <div v-if="dataLoaded">
    <v-card-title class="text-h5 align-center justify-center mb-8">
      {{ $t('orderInfoLabel') }}
    </v-card-title>
    <div class="product-information-container mb-9">
      <div class="d-flex align-start">
        <div class="product-info">
          <div class="text-h6 mb-2">{{ $t('ordersLabel') }}</div>
          <div class="body-1 mb-2">{{ $t('ordersNoLabel') }}: {{order.orderNo}}</div>
          <div class="body-1 mb-2">{{ $t('ordersCustNoLabel') }}: {{order.customerNo}}</div>
          <div class="body-1 mb-2">{{ $t('ordersNetValueLabel') }}: {{order.netValue}} €</div>
          <div class="body-1 mb-2">{{ $t('ordersSapValueLabel') }}: {{configNetValue}} €</div>
          <div class="body-1 mb-2">{{ $t('ordersCurrencyLabel') }}: {{order.currency}}</div>
          <div class="body-1 mb-2">{{ $t('ordersDateLabel') }}: {{order.orderDate}}</div>
          <div class="body-1 mb-2">{{ $t('ordersCompanyLabel') }}: {{order.company.name1}}</div>
          <div class="body-1 mb-2">{{ $t('ordersUserLabel') }}: {{order.user.fullName}}</div>
          <div class="body-1 mb-2">{{ $t('productIdLabel') }}: {{order.configurationId}}</div> 
          <div class="body-1 mb-2">{{ $t('configCreatedByUser') }}: {{order.productCreatedBy.userFullName}}</div>
          <div class="body-1 mb-2">{{ $t('configCreatedByCompany') }}: {{order.productCreatedByCompany.name1}}</div>
          <div class="body-1 mb-2">{{ $t('bestellnummerLabel') }}: {{purchNo}}</div>
        </div>
        <v-spacer></v-spacer>
        <div class="buttons-container d-flex align-center">
          <v-btn class="mr-2 elevation-0" fab dark small color="primary" download="Order.json"
            :href="jsonBase64File" v-if="jsonBase64File">
            <v-icon>mdi-code-json</v-icon>
          </v-btn>
          <v-btn class="mr-2 elevation-0" fab dark small color="primary" @click="generateNewPdf()">
            <img src="../assets/images/pdf-file.svg" height="25px" alt="" />
          </v-btn> 

          <v-spacer></v-spacer>
          <!-- <v-btn v-if="canCancelOrder" class="red white--text">{{ $t('cancelOrderLabel') }}</v-btn> -->
        </div>
      </div>
    </div>
    <v-flex class="mb-8">
      <div class="text-h6 mb-2">{{ $t('informationLabel') }}</div>
      <div class="text-body-1">{{ $t('orderInformationDescription') }}</div>
    </v-flex>
  </div>
</template>

<script>
  import {
    mapActions
  } from 'vuex';
  import UserTypes from '../auth/userTypes';
  import jsPDF from 'jspdf';
  import 'jspdf-autotable';
  export default {
    data() {
      return {
        jsonBase64File : '',
        order: {},
        purchNo: '',
        configNetValue: null,
        dataLoaded: false,
        canCancelOrder: false,
      }
    },
    methods: {
      ...mapActions('configuratorModule', ['setProductId']),

      async fetchOrder() {
        this.$EventBus.$emit("loading", true);
        await this.axios.get('api/order/getOrder', {
            params: {
              id: this.$route.params.orderId
            }
          })
          .then(response => {
            this.$EventBus.$emit("loading", false);
            this.order = response.data;
            const productConfiguration = JSON.parse(response.data.productConfiguration);
            const purchNoFiltered = productConfiguration.header.filter( e => (e.name === 'PURCH_NO_C'));
            const netValueFiltered = productConfiguration.header.filter(e => e.name === 'NETVALUE');
            this.purchNo = typeof purchNoFiltered !== 'undefined' ? purchNoFiltered[0].value : '';
            this.configNetValue = typeof netValueFiltered !== 'undefined' ? netValueFiltered[0].value : null;

            //this.setProductId(this.order.productConfiguration.id);
            this.dataLoaded = true;
            this.generateJsonData();
          })
          .catch(error => {
            console.log(error)
          })
      },

      generateJsonData() {
          var fileURL = window.URL.createObjectURL(new Blob([this.order.productConfiguration]))
          this.jsonBase64File = fileURL;
      },

      generatePdfData() {
          var data = this.order.productConfiguration;
          var parsedJson = JSON.parse(data);
          var doc = new jsPDF();

          var array = new Array();
          for (var i = 0; i < parsedJson.KTU.length; i++) {
            array.push(new Array(parsedJson.KTU[i].name, parsedJson.KTU[i].value));
          }

          doc.autoTable({
            head: [
              ['Name', 'Value']
            ],
            body: array,
          })

          doc.save('Order.pdf')  
      },
      generateNewPdf(){
        NProgress.start();
        this.axios.get('/api/productconfiguration/getProductPdfDataCustom', {
          params: {
            orderId: this.order.id
          }
        }).then(response => {
          const blob = this.b64toBlob(response.data, 'application/pdf');
          const blobUrl = URL.createObjectURL(blob);
          NProgress.done();

          const x = window.open(blobUrl, '_blank');
          setTimeout(() => {
            x.document.title = "Product Configuration"
          },1000)

        }).catch(error => {
          NProgress.done();
        });
      },
      b64toBlob(b64Data, contentType='', sliceSize=512){
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
    },
    mounted() {
      this.fetchOrder();
      
      if (parseInt(this.$store.state.user.userType) == UserTypes.WertheimAdministrator) {
        this.canCancelOrder = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .h-250 {
    height: 250px;
  }
</style>